export const SmsIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.00933 15C7.61267 15 7.212 14.8669 6.89267 14.5969L4.494 12.6764H3.66667C1.64467 12.6764 0 11.1128 0 9.1904V3.48601C0 1.56364 1.64467 0 3.66667 0H12.3333C14.3547 0 16 1.56364 16 3.48601V9.1904C16 11.1128 14.3547 12.6764 12.3333 12.6764H11.5527L9.08067 14.6191C8.782 14.872 8.39733 15 8.00933 15ZM3.66667 1.90146C2.748 1.90146 2 2.61261 2 3.48601V9.1904C2 10.0638 2.748 10.775 3.66667 10.775H4.85933C5.09533 10.775 5.32333 10.8542 5.50333 10.9987L8.00267 13.0003L10.5553 10.993C10.7353 10.8523 10.96 10.775 11.1927 10.775H12.3333C13.2527 10.775 14 10.0638 14 9.1904V3.48601C14 2.61261 13.2527 1.90146 12.3333 1.90146H3.66667Z" fill="white"/>
        </svg>
    `,
      }}
    />
  );
};
